const SIZES = { full: [905, 606], horizontal: [1157, 200], mark: [478, 431] };

export const HardwireLogo = ({ size = 46, variant = 'horizontal', tone = 'light', testId = 'hardwire-logo', className = '' }) => (
  <img
    src={`/media/brand/logo-${variant}-${tone === 'dark' ? 'on-dark' : 'transparent'}.png`}
    alt="Hardwire Electrical — Coming to you live!"
    data-testid={testId}
    width={SIZES[variant][0]}
    height={SIZES[variant][1]}
    style={{ height: size, width: 'auto', maxWidth: '100%', objectFit: 'contain' }}
    className={`select-none ${className}`}
  />
);
